import { FC, useState } from "react";
import { BsChatText } from "react-icons/bs";
import { RxAvatar } from "react-icons/rx";
import EcomotoChat from "../../pages/ecomotoChat/ecomotoChat";
import { useForm } from "react-hook-form";
import { logo } from "../../assets/images";

interface RentalChatProp {
  lesseeId: string;
  lessorId: string;
  rentalID: string;
  title?: string;
  className?: string;
}
const RentalChat: FC<RentalChatProp> = ({
  title,
  lesseeId,
  lessorId,
  rentalID,
  className,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [isUserChat, setIsUserChat] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();

  const onSubmit = (data: any) => {
    console.log(data?.file[0]);

    // Clear the form
    reset();

    // Close the chat form
    closeChat();
  };

  const openModal = () => {
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };
  const openChat = () => {
    setIsChatOpen(true);
    setIsOpen(!isOpen);
  };

  const closeChat = () => {
    setIsChatOpen(false);
  };
  return (
    <div>
      <button
        onClick={openModal}
        className={`flex items-center gap-2 py-[11px] w-[200px] justify-center bg-white px-auto border border-darkGreen rounded-lg text-[#19B375] font-bold text-[12px] leading-[150%] ${
          className ?? ""
        }  `}
      >
        <BsChatText className=" text-[#19B375] text-[24px]" />
        Chat
      </button>
      {isOpen && (
        <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center z-50 bg-black bg-opacity-50">
          <div className="bg-white p-8 rounded shadow-lg min-w-80">
            <h2 className="mb-4 text-lg font-semibold text-gray-700">
              Chat Options
            </h2>
            <div className="flex justify-between gap-10">
              <button
                type="button"
                className="flex flex-col gap-2 items-center w-full font-Jakarta text-base font-medium   text-darkGreen text-nowrap"
                onClick={() => {
                  openChat();
                  setIsUserChat(true);
                }}
              >
                <RxAvatar className="h-6 w-6 object-cover" />
                Chat with {title ? title : "Lessor"}
              </button>
              <button
                type="button"
                className="flex flex-col gap-2 items-center w-full font-Jakarta text-base font-medium  text-midGreen text-nowrap"
                onClick={openChat}
              >
                <img src={logo} alt="" className=" h-6 w-6 object-cover" />
                Chat with Ecomoto
              </button>
            </div>
            <button
              className="mt-4 block w-full py-2 px-4 rounded bg-red-500 text-white"
              onClick={closeModal}
            >
              Close
            </button>
          </div>
        </div>
      )}
      {isChatOpen && (
        <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center z-50 bg-black/50 picModal">
          {isUserChat ? (
            <EcomotoChat
              lesseeId={lesseeId}
              lessorId={lessorId}
              rentalID={rentalID}
              onClose={closeChat}
            />
          ) : (
            <div className="bg-white p-8 rounded shadow-lg min-w-80">
              <h2 className="mb-4 text-lg font-semibold text-gray-700">
                Send a Message to Ecomoto
              </h2>
              <form
                onSubmit={handleSubmit(onSubmit)}
                className="flex flex-col gap-3"
              >
                <label className="block mb-2">Subject</label>
                <div className="">
                  <input
                    {...register("subject", { required: true })}
                    type="text"
                    className="block w-full mb-4 p-2 border border-gray-300 rounded"
                  />

                  {errors.subject && (
                    <p className=" text-red-500">This field is required</p>
                  )}
                </div>

                <label className="block mb-2">Message</label>
                <div className="">
                  <textarea
                    {...register("message", { required: true })}
                    className="block w-full mb-4 p-2 border border-gray-300 rounded"
                  />

                  {errors.message && (
                    <p className=" text-red-500">This field is required</p>
                  )}
                </div>

                <label className="block mb-2">Attachment (optional)</label>
                <input
                  {...register("file")}
                  type="file"
                  className="block w-full mb-4 p-2 border border-gray-300 rounded"
                />

                <button
                  type="submit"
                  className="block w-full py-2 px-4 rounded bg-midGreen text-white"
                >
                  Send
                </button>
              </form>
              <button
                className="mt-4 block w-full py-2 px-4 rounded bg-red-500 text-white"
                onClick={closeChat}
              >
                Close
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default RentalChat;
